module.exports = __webpack_public_path__ + "static/img/qcsh2.38b8e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qcsh2.jpg
// module id = +W0r
// module chunks = 0